/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Discount_ShortInputs */

const vi_order_discount_short = /** @type {(inputs: Order_Discount_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CK (%)`)
};

/**

* @param {Order_Discount_ShortInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_discount_short = /** @type {((inputs?: Order_Discount_ShortInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Discount_ShortInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_discount_short(inputs)
});